import React,{useEffect, useRef}from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faGithub} from "@fortawesome/free-brands-svg-icons";
gsap.registerPlugin(ScrollTrigger); //scrollTriger 플러그인
function Contact(props) {
  const boxRef = useRef(null);
  const boxRef2 = useRef(null);
  const boxRef3 = useRef(null);
  useEffect(()=>{
    gsap.fromTo(
    boxRef.current,
    {x:200, opacity:0},
    {x: 0, opacity:1, duration:3, ease:'bounce.out', scrollTrigger:{
      trigger: boxRef.current, start:'top 80%', toggleActions:'play reverse play reverse',
    },
  }
)
  }, []);

    useEffect(()=>{
    gsap.fromTo(
    boxRef2.current,
    {x:-200, opacity:0},
    {x: 0, opacity:1, duration:3, ease:'bounce.out', scrollTrigger:{
      trigger: boxRef2.current, start:'top 80%', toggleActions:'play reverse play reverse',
    },
  }
)
  }, []);

  useEffect(()=>{
    gsap.fromTo(
    boxRef3.current,
    {x:200, opacity:0},
    {x: 0, opacity:1, duration:3, ease:'bounce.out', scrollTrigger:{
      trigger: boxRef3.current, start:'top 80%', toggleActions:'play reverse play reverse',
    },
  }
)
  }, []);
  return (
    <section className='contact' id='Contact'>
      <h2>Contact Us</h2>

      <div className='epilogue' ref={boxRef2}>
        <div>
          <h3>Epilogue</h3>
          <p> 지난 6개월간 프론트엔드 개발을 체계적으로 학습하며, <strong>단순한 기능 구현을 넘어 기술의 원리와 구조</strong>에 대한 깊은 관심을 가지게 되었습니다.</p>
          <p> 6개월이란 시간이 길지만 짧았고 처음 접하는 분야이기에 배울 것도 많았지만 그만큼 새로운 <span>도전</span>을 한다는거에 재미를 느꼈습니다.</p>
          <p> 궁금한 것이 생기면 끝까지 파고들고, 그것을 해결해 나가는 과정을 통해 스스로 성장하는 법을 배웠습니다.</p>
          <p> 앞으로도 끊임없는 탐구와 도전을 통해, 문제를 능동적으로 해결하고 가치 있는 경험을 제공하는 개발자로 나아가겠습니다.</p>
        </div>
      </div>

      <div className='contact_container' ref={boxRef}>
        <ul>
          <li>
            <h3>Mail & Portfolio</h3>
            <a href="mailto:chlghkqls123@naver.com">✉</a>
            <Link to='https://github.com/choihwabin' title='깃허브 저장소 바로가기'><FontAwesomeIcon icon={faGithub}/></Link>
            <Link to='https://pond-muscle-8d8.notion.site/217470e3561580b9aed6d582270b2ad4?source=copy_link' title='노션 포트폴리오 바로가기'>
              <img src={`${process.env.PUBLIC_URL}/images/notion.png`} alt='노션'/>
            </Link>
          </li>
          <li>
            <h3>Phone</h3>
            <Link to='tel:01082512301'>010 - 8251 - 2301</Link>
          </li>
        </ul>
      </div>

      <div className='sns' ref={boxRef3}>
        <div>
          <a href="https://www.instagram.com/tuesdayb1n"
          target="_blank"
          rel="noopener noreferrer"
          title='인스타 구경하기'
          >
            <img src={`${process.env.PUBLIC_URL}/images/instagram.svg`} alt='인스타그램' className='insta'/>
          </a>
          <a href="https://open.kakao.com/o/sPhqJNEh" title='카카오톡으로 연락하기'>
            <img src={`${process.env.PUBLIC_URL}/images/kakao.png`} alt='카카오톡' className='kakao'/>  
          </a>
          
        </div>
      </div>
    </section>
  );
}

export default Contact;